var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"600px"}},[_c('KLVideo',{ref:"klvideo",staticStyle:{"height":"100%","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }